export default {
  index: [
    {
      path: '/dpyjhd',
      component: resolve => require(['./dp_yjhdIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dp_yjhd/_router.js